// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var cloudHornRouter = {
  path: '/cloudHorn',
  component: Layout,
  redirect: '/cloudHorn/setting',
  name: 'CloudHorn',
  alwaysShow: true,
  meta: {
    title: '云喇叭',
    icon: 'clipboard',
    roles: ['admin']
  },
  children: [{
    path: 'setting',
    component: function component() {
      return import('@/views/cloudHorn/setting');
    },
    name: 'CloudHornSetting',
    meta: {
      title: '基础设置'
    }
  }, {
    path: 'MerchantBinding',
    component: function component() {
      return import('@/views/cloudHorn/merchantBinding');
    },
    name: 'CloudHornMerchantBinding',
    meta: {
      title: '商户绑定'
    }
  }]
};
export default cloudHornRouter;